import endpoints from "api/endpoints";
import axiosNeuron from "api/axios";
import { IAlertingConfig } from "types/placement";

interface IFacility {
  project?: number;
  name?: string;
  address?: string;
  description?: string;
}

interface IMachine {
  facility?: number | null;
  name?: string;
  subcategory?: number;
}

interface IPlacement {
  audio_chunk_type?: string;
  custom_name?: string;
  channel_number?: number;
}

interface IParams {
  facility?: IFacility;
  machine?: IMachine;
  device_serial_uid?: string;
  placements?: IPlacement[];
  alerting_config?: IAlertingConfig | null;
}

export default async function onboardMachine(params: IParams) {
  const url = endpoints.onboardMachine.default;
  try {
    const response = await axiosNeuron.post(url, params);
    return response.data;
  } catch (error) {
    if (error !== undefined) {
      throw error;
    }
  }
}
